import Col from 'components/ui-elements/Col'
import React from 'react'
import PhotoDropUpload from './PhotoDropUpload'

const PhotoDropUploadCol = (props) => {
  const { colsize, model, margin, ...rest } = props
  return (
    <Col size={colsize} model={model} margin={margin}>
      <PhotoDropUpload {...rest} />
    </Col>
  )
}

PhotoDropUploadCol.defaultProps = {
  colsize: 12,
  model: 'md',
  margin: 'mb-3',
}

export default PhotoDropUploadCol

